import React, {Fragment} from "react";
import ListView from "../../../components/ContentDisplay/ListView";
import CustomFieldDisplay from "../../../components/CustomFieldDisplay";
import DeleteModal from "../../../components/Modal/DeleteModal";
import {OBJECT_TYPES} from "../../../constants/objectTypes";
import WebhookModal from "../webhookModal";
import {ACTIONS_LIST, LIST_HEADERS, PERMS_FOR_ACTIONS} from "./constants";
import {useWebhooksTableActions} from "./useWebhooksTableActions";
import {useWebhooksTableData} from "./useWebhooksTableData";
import WebhookCard, {CustomRenderComponent} from "./webhookCard";

const WebhooksTable = () => {
  const {fetchAfterDelete, paginationConfig, webhookList, webhookTotalCount} =
    useWebhooksTableData();
  const {
    closeDeleteModal,
    closeEditModal,
    closeCustomFieldModal,
    handleActionSelection,
    handleDelete,
    isCustomFieldModalOpen,
    isDeleteModalOpen,
    isEditModalOpen,
    selectedRow,
  } = useWebhooksTableActions(fetchAfterDelete);

  return (
    <Fragment>
      {isCustomFieldModalOpen && (
        <CustomFieldDisplay
          objectId={selectedRow.id}
          objectType={OBJECT_TYPES.Webhook}
          onToggle={closeCustomFieldModal}
          open={isCustomFieldModalOpen}
        />
      )}
      {isEditModalOpen && (
        <WebhookModal
          data={selectedRow}
          onCancel={closeEditModal}
          open={isEditModalOpen}
        />
      )}
      {isDeleteModalOpen && (
        <DeleteModal
          header={"Delete Webhook"}
          modalBody={"Are you sure you want to delete this webhook ?"}
          onClose={closeDeleteModal}
          onDelete={handleDelete}
          open={isDeleteModalOpen}
        />
      )}
      <div className="table-container">
        <ListView
          actionsList={ACTIONS_LIST}
          cardContent={WebhookCard}
          customRenderComponent={CustomRenderComponent}
          listItems={webhookList}
          listHeaders={LIST_HEADERS}
          onSelectAction={handleActionSelection}
          permsForActions={PERMS_FOR_ACTIONS}
          totalCount={webhookTotalCount}
          withActions
          withPagination={paginationConfig}
        />{" "}
      </div>
    </Fragment>
  );
};

export default WebhooksTable;
